import entityContainerConnector from '~components/generic/entityContainerConnector';
import Video from '~modules/video/Video';

export default entityContainerConnector(Video);
